import React from 'react';
import { Grid, Box, Typography, Button } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { Fade } from '@mui/material';
import { ArrowForward, ChatBubbleOutline } from '@mui/icons-material';

const COLORS = {
  primary: '#123465',
  secondary: '#f9a838',
  white: '#fff',
};

export default function Contact() {
  return (
    <Box
      sx={{
        bgcolor: COLORS.primary,
        py: { xs: 5, md: 7 },
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Decorative elements */}
      <Box
        sx={{
          position: 'absolute',
          top: -80,
          right: -80,
          width: 280,
          height: 280,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(249,168,54,0.15) 0%, transparent 70%)',
          pointerEvents: 'none',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: -60,
          left: -60,
          width: 200,
          height: 200,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(255,255,255,0.05) 0%, transparent 70%)',
          pointerEvents: 'none',
        }}
      />

      <Grid
        container
        spacing={3}
        alignItems="center"
        justifyContent="center"
        sx={{
          maxWidth: 'lg',
          mx: 'auto',
          px: { xs: 3, md: 4 },
          position: 'relative',
          zIndex: 1,
        }}
      >
        <Grid item xs={12} md={7.5}>
          <Fade in appear={false} timeout={800}>
            <Box sx={{ color: COLORS.white }}>
              {/* Icon */}
              <Box
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 48,
                  height: 48,
                  borderRadius: '12px',
                  bgcolor: 'rgba(255,255,255,0.1)',
                  border: '1px solid rgba(255,255,255,0.15)',
                  mb: 2.5,
                }}
              >
                <ChatBubbleOutline sx={{ fontSize: 24, color: COLORS.secondary }} />
              </Box>

              <Typography
                variant="h2"
                sx={{
                  fontSize: { xs: '1.65rem', sm: '2rem', md: '2.35rem' },
                  fontWeight: 800,
                  lineHeight: 1.25,
                  mb: 1.75,
                  letterSpacing: '-0.3px',
                }}
              >
                Vous avez un projet ?{' '}
                <Box
                  component="span"
                  sx={{
                    color: COLORS.secondary,
                    position: 'relative',
                    '&::after': {
                      content: '""',
                      position: 'absolute',
                      bottom: -2,
                      left: 0,
                      width: '100%',
                      height: 2,
                      borderRadius: 1,
                      bgcolor: COLORS.secondary,
                      opacity: 0.4,
                    },
                  }}
                >
                  Parlons-en
                </Box>
              </Typography>
              
              <Typography
                variant="body1"
                sx={{
                  fontSize: { xs: '0.97rem', md: '1.05rem' },
                  fontWeight: 400,
                  lineHeight: 1.7,
                  color: 'rgba(255,255,255,0.75)',
                  maxWidth: 520,
                }}
              >
                Notre équipe d'experts est disponible pour vous accompagner 
                et vous proposer des solutions adaptées à vos besoins.
              </Typography>
            </Box>
          </Fade>
        </Grid>
        
        <Grid item xs={12} md={4.5}>
          <Fade in appear={false} timeout={1200}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: { xs: 'center', md: 'flex-end' },
                alignItems: 'center',
                gap: 2,
              }}
            >
              <Button
                component={NavLink}
                to="/contactus"
                onClick={() => window.scrollTo(0, 0)}
                variant="contained"
                size="large"
                endIcon={<ArrowForward />}
                sx={{
                  bgcolor: COLORS.secondary,
                  color: COLORS.primary,
                  fontWeight: 700,
                  fontSize: { xs: '0.95rem', md: '1rem' },
                  px: 4,
                  py: 1.5,
                  borderRadius: '12px',
                  textTransform: 'none',
                  boxShadow: '0 8px 24px rgba(249,168,54,0.35)',
                  transition: 'all 0.25s ease',
                  '&:hover': {
                    bgcolor: '#ffb948',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 12px 32px rgba(249,168,54,0.45)',
                  },
                }}
                aria-label="Contactez un expert pour discuter de votre projet"
              >
                Contactez un expert
              </Button>
            </Box>
          </Fade>
        </Grid>
      </Grid>
    </Box>
  );
}
